import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { Link } from '@sitecore-jss/sitecore-jss-vue';
import { LinkField } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';

interface Props {
  field?: LinkField;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SafeLink',
  props: {
    field: {}
  },
  setup(__props: any) {

const props = __props;

/**
* Fix tel: and mailto: links if Sitecore prepended http://
* Keep normal links and anchors intact
*/

const safeHref = computed(() => {
  const link = props.field?.value;
  if (!link?.href) return null;

  let url = link.href;

  if (url.startsWith('http://tel:') || url.startsWith('http://mailto:')) {
    url = url.replace('http://', '');
  }

  if (link.anchor) {
    url += `#${link.anchor}`;
  }

  return url;
});

return (_ctx: any,_cache: any) => {
  return (safeHref.value)
    ? (_openBlock(), _createBlock(_unref(Link), {
        key: 0,
        field: { ...props.field, value: { ...props.field?.value, href: safeHref.value } }
      }, null, 8, ["field"]))
    : _createCommentVNode("", true)
}
}

})